import { ResponsiveBar } from '@nivo/bar'
import { ResponsivePie } from '@nivo/pie';
import { useGetInoutStatusStatic } from '../../../interface/inout';
import theme from '../../../styles/theme';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const ChartStaticItemStatus = () => {

    const navigate = useNavigate();

    const {data: staticInoutStatus, isLoading: staticInoutStatusLoading} = useGetInoutStatusStatic();
    const [chartData, setChartData] = useState([])

    useEffect(()=>{

        if(staticInoutStatus){
            const temp = staticInoutStatus.map((item)=> ({
                                    'cat_nm': item.cat_nm +'('+item.tot_cnt+')',
                                    '가용': item.tot_cnt - item.use_tot_cnt,
                                    '반출': item.use_scnt,
                                    '고장/수리': item.use_fcnt + item.use_ecnt,
                                    '기타': item.use_xcnt + item.not_cnt,
                                }))
            setChartData(temp);
        }

    },[staticInoutStatus])

    return (
        <React.Fragment>
            {(chartData && chartData.length > 0) &&
                chartData.map((item,index)=> (
                    <div key={index} style={{height:(chartData.length - 1) === index ? '150px':'52px'}}>
                <ResponsiveBar
                    data={[item]}
                    keys={[
                        '가용',
                        '반출',
                        '고장/수리',
                        '기타',
                    ]}
                    indexBy="cat_nm"
                    margin={{ top: 0, right: 24, bottom: (chartData.length - 1) === index ? 100: 0, left: 100 }}
                    padding={0.2}
                    innerPadding={3}
                    //groupMode="grouped"
                    layout="horizontal"
                    valueScale={{ type: 'linear' }}
                    indexScale={{ type: 'band', round: true }}
                    colors={{ scheme: 'nivo' }}
                    borderColor={{ theme: 'background' }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legendOffset: -40
                    }}
                    enableGridY={false}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={'#333333'}
                    tooltip={ToolTip}
                    onClick={(node,event)=>navigate('/admin/static/searchItem')}
                    legends={
                        (chartData.length - 1) === index ? [{
                            dataFrom: 'keys',
                            anchor: 'bottom',
                            direction: 'row',
                            justify: false,
                            translateX: 0,
                            translateY: 60,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 80,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1
                                    }
                                }
                            ],
                            onClick:(datum,event)=>navigate('/admin/static/searchItem')
                        }
                    ]:[]}
                />
                </div>
                ))}
        </React.Fragment>
    )
}


const SubWrap = styled.div`
    background: #ffffff;
    padding: 6px;
    // border: 1px solid red;
    font-size: 1rem;
    line-height: 1.2rem;
    // color: ${(props)=>props.color};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const ToolTip = (param) => {

    return (
        <SubWrap>
            <svg width={15} height={15}>
                <rect x={0} y={0} fill={param.color} width={15} height={15}/>
            </svg>&nbsp;
            {param.id} : {param.formattedValue}
        </SubWrap>
    )

}

export default ChartStaticItemStatus;